import { PRIMITIVE } from "@/tokens/design-tokens";

// Sections a provider may leave empty; every other visible section must be answered before signing.
export const INITIAL_F2F_OPTIONAL_SECTION_KEYS = [
  "screening",
  "miniCog",
  "annualWellness",
  "diabeticScreening",
  "smokingScreening",
  "obesityScreening",
] as const;

export const REQUIRED_SECTION_LABELS = {
  required: "Required",
  fillBefore: "Complete required fields to save and sign:",
  signBlocked: (titles: string[]) =>
    `Fill in the required sections before signing: ${titles.join(", ")}.`,
  vitalsInvalid: (labels: string[]) =>
    `Correct the Vital Signs before signing: ${labels.join(", ")}.`,
} as const;

// Soft reds from the design tokens, so the highlight matches the rest of the app.
export const REQUIRED_SECTION_COLORS = {
  required: PRIMITIVE.color.red[300],
  requiredBackground: PRIMITIVE.color.red["00"],
  neutralChip: PRIMITIVE.color.neutrals[2100],
  neutralBorder: PRIMITIVE.color.neutrals[1200],
} as const;

export const REQUIRED_SECTION_ELEMENT_ID_PREFIX = "visit-note-section-";
// Keeps the section clear of the sticky note header when scrolled into view.
export const REQUIRED_SECTION_SCROLL_OFFSET_PX = 16;
/** Formik status key holding the required-section keys found empty when Save & Sign was last pressed. */
export const REQUIRED_SECTIONS_MISSING_STATUS = "requiredSectionsMissing";
/** Formik status key counting Save & Sign presses, so each press re-focuses the first empty section. */
export const REQUIRED_SECTIONS_ATTEMPT_STATUS = "requiredSectionsAttempt";
